import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const STATS = [
  { value: "35+", label: "Anni di esperienza sul campo" },
  { value: "1.200+", label: "Coperture realizzate" },
  { value: "100%", label: "Garanzia di tenuta idrica" },
];

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="chi-siamo" ref={ref} className="py-24 sm:py-32 bg-[#0B0C0E]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D97736] mb-4">
            La nostra storia &amp; maestria
          </p>
          <h2 className="font-syne font-bold tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl mb-6">
            Oltre 35 anni di ingegneria delle coperture e maestria artigianale.
          </h2>
          <p className="text-base sm:text-lg text-[#9CA3AF] font-light leading-relaxed mb-10">
            Fondata ad Abbiategrasso, alle porte di Milano, MERLO coperture nasce dall'unione tra la
            passione per l'artigianato edile lombardo e la costante ricerca di materiali e tecnologie di
            impermeabilizzazione all'avanguardia. Ogni copertura è progettata per durare generazioni.
          </p>
          <div className="grid grid-cols-3 gap-6">
            {STATS.map((s) => (
              <div key={s.label} className="border-l-2 border-[#D97736]/50 pl-4">
                <p className="font-syne font-bold text-2xl sm:text-4xl text-[#F3F4F6]">{s.value}</p>
                <p className="text-xs sm:text-sm text-[#6B7280] mt-1 leading-snug">{s.label}</p>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-3xl overflow-hidden border border-white/10 h-[380px] sm:h-[520px]"
        >
          <motion.img
            src="https://images.unsplash.com/photo-1601658797866-7ae55d05a817?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHx0ZXJyYWNvdHRhJTIwcm9vZiUyMHRpbGVzJTIwYXJjaGl0ZWN0dXJlJTIwZGV0YWlsfGVufDB8fHx8MTc5Mjc5MDA2OHww&ixlib=rb-4.1.0&q=85"
            alt="Copertura in tegole di terracotta al tramonto"
            loading="lazy"
            style={{ y: imgY }}
            className="absolute inset-0 w-full h-[116%] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C0E]/70 via-transparent to-transparent" />
          <p className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#F3F4F6]/80">
            Manto in tegole — restauro conservativo
          </p>
        </motion.div>
      </div>
    </section>
  );
}
